<template>
  <div id="Login" class="">
    <div class="login">
      <div class="loginH1">
        <h1>メールアドレス/パスワードを<br>入力してください</h1>
      </div>
      <ul>
      <li><input type="email" placeholder="Mail address" v-model="email" v-on:keydown.enter="signIn" ref="inuptEmail"></li>
      <li><input :type="inputType" placeholder="Password" v-model="password" v-on:keydown.enter="signIn" ref="inputPasswrad"><input type="checkbox" @click="appearPassward" id="InputPasswradAppear"><label for="InputPasswradAppear">{{this.isCheckedMessage}}</label></li>
      </ul>
      <p class="loginAlert">
  {{ registerErrorText }}<br>
  {{ registerErrorCode }}
      </p>
      <button @click="signIn">LOGIN</button>
  <!--
      <p>You don't have an account? 
        <router-link to="/register">create account now!!</router-link>
      </p>
  -->
    </div>
  </div>
</template>

<script>
import axios from '../axios-auth.js'

var isChecked = false
var isCheckedMessage = "パスワードの入力文字を確認する"

export default {
  name: 'login',
/* vue-head 表記内容 */
  head: {
    title() {
      return {
        inner: this.$route.name,
        separator: '|',
        complement: this.$store.getters.siteName,
      }
    },
    meta: [
      { name: 'description', content: 'Vue.jsサイト構築', id: 'desc' }
    ]
  },
  data: function () {
    return {
      email: '',
      password: '',
      registerErrorCode:'',
      registerErrorText:'',
      isChecked,
      isCheckedMessage,
    }
  },
  computed:{
    inputType: function () {
      return this.isChecked ? "text" : "password"
    },
  },
  mounted: function() {
//インナーナビ情報通知
    this.$store.commit('updatePageSectionInfo', '')
//背景通知
    this.$store.commit('updatePageBackgroundStyle', '')
  },
  methods: {
    signIn:function(e) {
      axios.post('/accounts:signInWithPassword?key=AIzaSyB0tzvdnGh4oeOL7Nwi3bWPllxq5OweoH0', 
        {
          'email':this.email,
          'password':this.password,
          'returnSecureToken':true
        }
      ).then((response) => {
        this.$store.commit('updateIdToken', response.data.idToken)
        this.$router.push('/')
      })
      .catch((error) => {
        this.registerErrorCode = error.response.data.error.code
        this.registerErrorText = error.response.data.error.message
      })
/*      this.email = ""
      this.password = ""
      this.registerErrorCode = ''
      this.registerErrorText = ''*/
    },
    appearPassward:function() {
      this.isChecked = !this.isChecked
      this.isCheckedMessage = this.isChecked?"パスワード非表示にする":"パスワードの入力文字を確認する"
console.log("appearPassward")
    },
  }
}
</script>

<style>
</style>
